function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingRequested({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.222,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 21.679,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.558,
    y: 393.306,
    style: {
      fill: "#EBEBEB"
    },
    width: 34.109,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 44.525,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.877,
    y: 394.25,
    style: {
      fill: "#EBEBEB"
    },
    width: 11.138,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.585,
    y: 394.25,
    style: {
      fill: "#EBEBEB"
    },
    width: 38.389,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.307,
    y: 390.028,
    style: {
      fill: "#EBEBEB"
    },
    width: 27.695,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M390.384,303.858v0.006c-0.377,0-0.756,0.009-1.138,0.04 c-8.036,0.643-14.534,8.3-15.046,17.722c-0.117,2.152,0.072,4.232,0.522,6.188c1.851,8.057,2.543,16.42,2.543,24.764v24.315 c0,1.763,1.219,3.192,2.723,3.192h10.396h-1.784h45.053v-76.226H390.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M449.872,322.868c0-10.94-7.884-19.722-17.356-18.964c-8.036,0.643-14.534,8.3-15.046,17.722 c-0.117,2.152,0.073,4.232,0.522,6.188c1.851,8.057,2.543,16.42,2.543,24.764v24.315c0,1.763,1.219,3.192,2.723,3.192h20.792 c1.504,0,2.723-1.429,2.723-3.192v-25.743c0-7.827,0.728-15.659,2.512-23.201 C449.668,326.331,449.872,324.628,449.872,322.868z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 354.671,
    y: 336.983,
    style: {
      fill: "#F5F5F5"
    },
    width: 56.636,
    height: 43.102
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M361.65,238.38h-62.242c-7.339,0-12.77,5.95-12.129,13.289l8.084,92.598h88.82l-8.084-92.598 C375.459,244.33,368.989,238.38,361.65,238.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M369.605,238.38h-56.033c-7.236,0-12.59,5.866-11.958,13.102l8.101,92.784h82.237l-8.101-92.784 C383.22,244.246,376.841,238.38,369.605,238.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M411.262,335.429h-52.937c-0.47,0-0.851,0.381-0.851,0.851v8.582 c0,0.47,0.381,0.851,0.851,0.851h52.937c1.573,0,2.849-1.275,2.849-2.849v-4.586 C414.111,336.704,412.835,335.429,411.262,335.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M432.334,382.398H301.315c-1.181,0-2.137-0.957-2.137-2.137v-0.177h135.294v0.177 C434.471,381.441,433.514,382.398,432.334,382.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M299.994,303.858v0.006c-0.377,0-0.756,0.009-1.138,0.04c-8.036,0.643-14.534,8.3-15.046,17.722 c-0.117,2.152,0.073,4.232,0.522,6.188c1.851,8.057,2.543,16.42,2.543,24.764v24.315c0,1.763,1.219,3.192,2.723,3.192h10.396 h10.396h45.053v-76.226H299.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M371.661,322.868c0-10.94-7.884-19.722-17.356-18.964c-8.036,0.643-14.534,8.3-15.046,17.722 c-0.117,2.152,0.073,4.232,0.522,6.188c1.851,8.057,2.543,16.42,2.543,24.764v24.315c0,1.763,1.219,3.192,2.723,3.192h20.792 c1.504,0,2.723-1.429,2.723-3.192v-25.743c0-7.827,0.728-15.659,2.512-23.201C371.457,326.331,371.661,324.628,371.661,322.868 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 389.143,
    y: 352.166,
    style: {
      fill: "#F0F0F0"
    },
    width: 51.743,
    height: 30.232
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M441.212,350.612h-52.396c-1.171,0-2.12,0.949-2.12,2.12v6.043c0,1.171,0.949,2.12,2.12,2.12 h52.396c1.171,0,2.12-0.949,2.12-2.12v-6.043C443.333,351.562,442.383,350.612,441.212,350.612z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.507,
    y: 247.101,
    style: {
      fill: "#E6E6E6"
    },
    width: 13.204,
    height: 51.17
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "204.374,298.27 108.688,298.27 102.07,238.38 197.755,238.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "209.12,298.27 111.991,298.27 105.373,238.38 202.502,238.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "115.262,293.551 109.687,243.1 199.231,243.1 204.806,293.551  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.308,281.322l-0.227-2.056c-1.399-12.657,6.504-23.938,16.77-23.938l0,0l0.227,2.056 C148.476,270.041,140.574,281.322,130.308,281.322L130.308,281.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M149.888,281.322l-0.227-2.056c-1.399-12.657,6.504-23.938,16.77-23.938h0l0.227,2.056 C168.057,270.041,160.154,281.322,149.888,281.322L149.888,281.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M169.468,281.322l-0.227-2.056c-1.399-12.657,6.504-23.938,16.77-23.938l0,0l0.227,2.056 C187.637,270.041,179.734,281.322,169.468,281.322L169.468,281.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.747,
    y: 298.27,
    style: {
      fill: "#E6E6E6"
    },
    width: 56.686,
    height: 84.128
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "267.732,382.398 273.433,382.398 273.433,366.18 261.753,366.18  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.872,
    y: 298.27,
    style: {
      fill: "#E6E6E6"
    },
    width: 56.687,
    height: 84.128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.582,
    y: 298.27,
    style: {
      fill: "#F0F0F0"
    },
    width: 163.851,
    height: 74.176
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "115.284,382.398 109.582,382.398 109.582,366.18 121.263,366.18  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.006,
    y: 302.91,
    style: {
      fill: "#E6E6E6"
    },
    width: 155.004,
    height: 29.931
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M201.845,312.211h-20.674c-8.98,0-17.565-3.693-23.742-10.211l0,0h68.157l0,0 C219.411,308.518,210.826,312.211,201.845,312.211z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.006,
    y: 337.678,
    style: {
      fill: "#E6E6E6"
    },
    width: 155.004,
    height: 29.931
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M201.845,346.979h-20.674c-8.98,0-17.565-3.692-23.742-10.211l0,0h68.157l0,0 C219.411,343.287,210.826,346.979,201.845,346.979z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.776,
    y: 81.252,
    style: {
      fill: "#E6E6E6"
    },
    width: 364.772,
    height: 124.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.472,
    y: 81.252,
    style: {
      fill: "#F0F0F0"
    },
    width: 366.706,
    height: 124.003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.776,
    y: 205.255,
    style: {
      fill: "#E6E6E6"
    },
    width: 364.772,
    height: 6.746
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.519,
    y: 205.255,
    style: {
      fill: "#F0F0F0"
    },
    width: 366.706,
    height: 6.746
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.905,
    y: -35.018,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 391.0778 -104.5714)",
    style: {
      fill: "#FAFAFA"
    },
    width: 113.839,
    height: 356.542
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "375.042,200.173 383.181,86.334 397.261,86.334 389.123,200.173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "95.725,200.173 103.863,86.334 117.944,86.334 109.805,200.173  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M71.907,142.192c-0.215,0-0.389-0.174-0.389-0.389V89.64c0-0.215,0.174-0.389,0.389-0.389 c0.215,0,0.389,0.174,0.389,0.389v52.163C72.296,142.018,72.122,142.192,71.907,142.192z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "392.147,200.173 400.286,86.334 405.775,86.334 397.637,200.173  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.853,
    y: 142.93,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 569.0259 -282.5196)",
    style: {
      fill: "#E6E6E6"
    },
    width: 113.839,
    height: 0.645
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#E0E0E0"
    },
    points: "432.379,95.548 67.607,95.548 67.14,88.309 431.912,88.309  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#E0E0E0"
    },
    points: "432.379,107.447 67.607,107.447 67.14,100.209 431.912,100.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#E0E0E0"
    },
    points: "432.379,119.346 67.607,119.346 67.14,112.108 431.912,112.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#E0E0E0"
    },
    points: "432.379,131.246 67.607,131.246 67.14,124.007 431.912,124.007  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#E0E0E0"
    },
    points: "432.379,143.145 67.607,143.145 67.14,135.906 431.912,135.906  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#E0E0E0"
    },
    points: "432.379,155.044 67.607,155.044 67.14,147.806 431.912,147.806  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M57.03,149.907c-6.19-49.913,26.421-77.702,67.475-71.29c19.689,3.075,41.272,27.644,60.226,34.824 c24.727,9.367,47.41,3.813,71.727,5.529c60.484,4.269,57.441,28.769,95.113,65.364c26.485,25.728,72.664,28.816,84.355,69.695 c14.287,49.96-41.299,66.575-81.304,54.617c-45.948-13.734-64.212,42.899-134.947,27.867 C150.094,321.725,65.318,224.961,57.03,149.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M57.03,149.907c-6.19-49.913,26.421-77.702,67.475-71.29 c19.689,3.075,41.272,27.644,60.226,34.824c24.727,9.367,47.41,3.813,71.727,5.529c60.484,4.269,57.441,28.769,95.113,65.364 c26.485,25.728,72.664,28.816,84.355,69.695c14.287,49.96-41.299,66.575-81.304,54.617 c-45.948-13.734-64.212,42.899-134.947,27.867C150.094,321.725,65.318,224.961,57.03,149.907z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__217_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Post"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.444,
    y: 109.263,
    style: {
      fill: "#407BFF"
    },
    width: 8.222,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.111,
    y: 109.263,
    style: {
      fill: "#407BFF"
    },
    width: 28.222,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M112.583,266.672h201.296c4.553,0,7.946-3.725,7.54-8.278L309.18,121.041 c-0.406-4.553-4.463-8.278-9.016-8.278H98.869c-4.553,0-7.946,3.725-7.54,8.278l12.239,137.353 C103.973,262.947,108.031,266.672,112.583,266.672z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M113.229,266.672h201.296c4.553,0,7.946-3.725,7.54-8.278l-12.239-137.353 c-0.406-4.553-4.463-8.278-9.016-8.278H99.515c-4.553,0-7.946,3.725-7.54,8.278l12.239,137.353 C104.619,262.947,108.676,266.672,113.229,266.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M113.229,266.672h201.296c4.553,0,7.946-3.725,7.54-8.278l-12.239-137.353 c-0.406-4.553-4.463-8.278-9.016-8.278H99.515c-4.553,0-7.946,3.725-7.54,8.278l12.239,137.353 C104.619,262.947,108.676,266.672,113.229,266.672z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M301.179,116.902H99.883c-0.228,0-0.452,0.009-0.674,0.028c-5.138,0.424-3.953,8.25,1.24,8.25 h201.639c5.193,0,4.983-7.827-0.23-8.25C301.633,116.911,301.407,116.902,301.179,116.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M103.468,123.438c-1.299,0-2.45-1.056-2.565-2.354c-0.058-0.65,0.144-1.263,0.568-1.727 c0.422-0.462,1.011-0.716,1.658-0.716c1.299,0,2.449,1.056,2.565,2.354c0.058,0.65-0.144,1.263-0.567,1.727 C104.705,123.184,104.116,123.438,103.468,123.438z M103.13,119.643c-0.363,0-0.69,0.139-0.92,0.391 c-0.233,0.254-0.343,0.596-0.31,0.963c0.071,0.795,0.774,1.442,1.569,1.442c0.364,0,0.691-0.139,0.921-0.391 c0.232-0.254,0.342-0.596,0.309-0.963l0,0C104.628,120.29,103.924,119.643,103.13,119.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M109.924,123.438c-1.299,0-2.45-1.056-2.565-2.354c-0.058-0.65,0.144-1.263,0.568-1.727 c0.422-0.462,1.011-0.716,1.658-0.716c1.299,0,2.449,1.056,2.565,2.354l0,0c0.058,0.65-0.144,1.263-0.568,1.727 C111.16,123.185,110.571,123.438,109.924,123.438z M109.585,119.643c-0.363,0-0.69,0.139-0.92,0.391 c-0.233,0.254-0.343,0.596-0.31,0.963c0.071,0.795,0.774,1.442,1.569,1.442c0.363,0,0.691-0.139,0.921-0.391 c0.232-0.254,0.342-0.596,0.31-0.963l0,0C111.084,120.29,110.38,119.643,109.585,119.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M116.379,123.438c-1.298,0-2.449-1.056-2.565-2.354c-0.058-0.65,0.144-1.263,0.568-1.727 c0.422-0.461,1.012-0.716,1.659-0.716c1.298,0,2.449,1.056,2.565,2.354l0,0c0.058,0.65-0.144,1.263-0.568,1.727 C117.616,123.185,117.026,123.438,116.379,123.438z M116.041,119.643c-0.363,0-0.69,0.139-0.921,0.391 c-0.232,0.254-0.342,0.596-0.31,0.963c0.071,0.795,0.775,1.442,1.569,1.442c0.364,0,0.691-0.139,0.921-0.391 c0.232-0.254,0.342-0.596,0.31-0.963l0,0C117.539,120.29,116.835,119.643,116.041,119.643z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M116.357,252.963h192.596c1.657,0,2.881-1.344,2.734-3.001l-10.065-112.955 c-0.148-1.657-1.611-3.001-3.268-3.001H105.757c-1.657,0-2.881,1.344-2.734,3.001l10.065,112.955 C113.236,251.62,114.7,252.963,116.357,252.963z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M183.251,342.798c2.684,8.192-0.961,14.834-9.161,14.833c45.426,0,90.852,0,136.278,0 c8.198,0,11.846-6.642,9.161-14.833C274.103,342.799,228.677,342.799,183.251,342.798z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M124.887,142.354c29.208,66.815,6.625,133.63,28.697,200.444c0,0,0,0,0,0 c2.683,8.192,12.321,14.834,20.506,14.833c8.199,0,11.845-6.642,9.161-14.833c40.482,0,80.963,0,121.444,0 c-22.071-66.815,0.512-133.63-28.697-200.444C225.628,142.354,175.258,142.354,124.887,142.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M124.887,142.354c29.208,66.815,6.625,133.63,28.697,200.444c0,0,0,0,0,0 c2.683,8.192,12.321,14.834,20.506,14.833c8.199,0,11.845-6.642,9.161-14.833c40.482,0,80.963,0,121.444,0 c-22.071-66.815,0.512-133.63-28.697-200.444C225.628,142.354,175.258,142.354,124.887,142.354z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M189.334,193.021c-12.25,0-24.5,0-36.75,0c-1.685-12.25-4.29-24.5-8.413-36.75 c12.25,0,24.5,0,36.75,0C185.043,168.521,187.649,180.771,189.334,193.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#407BFF"
    },
    d: "M288.321,332.577c-27.333,0-54.667,0-82,0c-3.556-13.373-5.521-26.745-6.666-40.118 c27.333,0,54.666,0,82,0C282.801,305.831,284.765,319.204,288.321,332.577z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M269.35,160.352c-27.333,0-54.667,0-82,0c-0.422-1.361-0.861-2.721-1.318-4.081 c27.333,0,54.666,0,82,0C268.489,157.631,268.929,158.992,269.35,160.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M272.288,170.967c-27.333,0-54.667,0-82,0c-0.334-1.361-0.683-2.721-1.049-4.081 c27.333,0,54.667,0,82,0C271.605,168.246,271.954,169.607,272.288,170.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M256.142,181.582c-21.185,0-42.371,0-63.556,0c-0.257-1.36-0.528-2.721-0.813-4.081 c21.185,0,42.37,0,63.556,0C255.614,178.861,255.884,180.222,256.142,181.582z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M277.934,206.262c-27.334,0-54.667,0-82,0c-0.081-0.896-0.164-1.793-0.253-2.689 c27.334,0,54.667,0,82,0C277.77,204.469,277.853,205.365,277.934,206.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M278.488,213.255c-27.333,0-54.667,0-82,0c-0.062-0.896-0.128-1.793-0.196-2.689 c27.333,0,54.667,0,82,0C278.36,211.463,278.426,212.359,278.488,213.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M256.135,220.249c-19.74,0-39.481,0-59.222,0c-0.047-0.896-0.097-1.793-0.15-2.689 c19.741,0,39.481,0,59.222,0C256.038,218.457,256.088,219.353,256.135,220.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M279.233,227.244c-27.333,0-54.667,0-82,0c-0.035-0.896-0.073-1.793-0.112-2.689 c27.333,0,54.667,0,82,0C279.16,225.451,279.198,226.347,279.233,227.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M279.474,234.238c-27.333,0-54.667,0-82,0c-0.027-0.896-0.055-1.793-0.084-2.689 c27.333,0,54.667,0,82,0C279.419,232.445,279.447,233.341,279.474,234.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M216.381,241.232c-6.241,0-12.481,0-18.722,0c-0.021-0.897-0.043-1.793-0.066-2.689 c6.241,0,12.481,0,18.722,0C216.338,239.439,216.36,240.335,216.381,241.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M279.813,248.226c-27.333,0-54.667,0-82,0c-0.019-0.896-0.037-1.793-0.057-2.689 c27.333,0,54.667,0,82,0C279.775,246.433,279.794,247.329,279.813,248.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M279.961,255.22c-27.333,0-54.667,0-82,0c-0.02-0.896-0.039-1.793-0.058-2.689 c27.333,0,54.667,0,82,0C279.922,253.427,279.941,254.323,279.961,255.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M280.127,262.214c-27.333,0-54.667,0-82,0c-0.023-0.897-0.046-1.793-0.068-2.689 c27.333,0,54.667,0,82,0C280.081,260.421,280.104,261.317,280.127,262.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M280.336,269.208c-27.333,0-54.667,0-82,0c-0.03-0.896-0.06-1.793-0.087-2.689 c27.333,0,54.667,0,82,0C280.277,267.415,280.306,268.311,280.336,269.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M280.613,276.202c-27.333,0-54.667,0-82,0c-0.041-0.896-0.079-1.793-0.116-2.689 c27.333,0,54.667,0,82,0C280.534,274.409,280.572,275.305,280.613,276.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M233.593,283.196c-11.537,0-23.074,0-34.611,0c-0.054-0.896-0.106-1.793-0.154-2.689 c11.537,0,23.074,0,34.611,0C233.488,281.403,233.539,282.299,233.593,283.196z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M368.31,162.916c0.898,1.097,1.66,2.072,2.431,3.135c0.768,1.043,1.518,2.092,2.253,3.155 c1.464,2.129,2.86,4.305,4.168,6.554c1.297,2.258,2.569,4.535,3.678,6.943c1.134,2.39,2.183,4.846,3.018,7.462l0.321,0.974 l0.08,0.243l0.123,0.42c0.092,0.317,0.152,0.618,0.207,0.922c0.213,1.214,0.176,2.282,0.069,3.245 c-0.244,1.92-0.797,3.438-1.387,4.837c-1.196,2.773-2.713,5.03-4.268,7.194c-3.183,4.277-6.685,7.944-10.601,11.388l-4.069-3.724 c2.68-3.967,5.344-8.119,7.515-12.201c1.09-2.028,2.028-4.117,2.604-5.984c0.279-0.921,0.429-1.808,0.409-2.363 c-0.003-0.27-0.045-0.457-0.081-0.46c-0.009,0-0.011-0.003-0.017,0.019c-0.01-0.012,0.018,0.059-0.016-0.023l-0.082-0.193 l-0.328-0.77c-1.739-4.107-4.096-8.192-6.616-12.175c-1.266-1.995-2.605-3.961-3.956-5.918c-1.33-1.94-2.808-3.923-4.134-5.701 L368.31,162.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M366.846,214.41l-6.698,1.943l5.338,6.245c0,0,4.515-2.138,4.059-5.667L366.846,214.41z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "355.345,221.724 361.419,226.56 365.486,222.598 360.148,216.354  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M331.33,130.693c0,0.592-0.314,1.073-0.701,1.073s-0.701-0.48-0.701-1.073 c0-0.593,0.314-1.073,0.701-1.073S331.33,130.101,331.33,130.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A02724"
    },
    d: "M331.071,131.766c0,0-1.347,3.418-2.831,5.068c1.048,0.979,2.831,0.531,2.831,0.531V131.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M333.43,127.41c-0.071,0-0.142-0.021-0.203-0.066c-1.259-0.907-2.46-0.459-2.472-0.454 c-0.179,0.069-0.381-0.02-0.45-0.199c-0.069-0.179,0.02-0.381,0.199-0.45c0.063-0.024,1.568-0.587,3.13,0.539 c0.156,0.112,0.191,0.33,0.079,0.486C333.645,127.36,333.538,127.41,333.43,127.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M350.455,137.525c-1.054,5.374-2.105,15.222,1.655,18.808c0,0-1.469,5.452-11.455,5.452 c-10.981,0-5.248-5.451-5.248-5.451c5.993-1.431,5.838-5.878,4.794-10.053L350.455,137.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M353.548,158.204c0.787-1.726,1.654-3.701-0.139-4.319c-1.972-0.681-12.768-1.375-16.49-0.097 c-3.722,1.278-2.667,4.778-2.667,4.778L353.548,158.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M388.264,395.021c-0.574,0.487-1.205,0.872-1.66,0.772c-0.191-0.042-0.438-0.186-0.529-0.634 c-0.048-0.236,0.004-0.458,0.154-0.663c0.655-0.888,3.1-1.139,3.204-1.15c0.068-0.007,0.134,0.027,0.168,0.087 c0.034,0.059,0.03,0.134-0.01,0.189C389.363,393.936,388.842,394.531,388.264,395.021z M386.658,394.548 c-0.059,0.05-0.109,0.102-0.149,0.156c-0.091,0.123-0.121,0.25-0.093,0.387c0.065,0.32,0.214,0.352,0.263,0.363 c0.507,0.11,1.655-0.854,2.372-1.706C388.316,393.86,387.167,394.116,386.658,394.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M389.564,393.653c-0.022,0.018-0.048,0.032-0.077,0.038c-0.847,0.177-3.009-0.099-3.42-0.824 c-0.074-0.132-0.157-0.398,0.127-0.706c0.184-0.2,0.423-0.304,0.709-0.309c1.102-0.021,2.608,1.482,2.671,1.546 c0.045,0.045,0.062,0.111,0.043,0.173C389.608,393.603,389.589,393.632,389.564,393.653z M386.506,392.342 c-0.02,0.017-0.039,0.035-0.057,0.055c-0.154,0.167-0.102,0.259-0.08,0.299c0.243,0.428,1.744,0.75,2.691,0.698 c-0.466-0.417-1.445-1.207-2.151-1.193C386.748,392.203,386.615,392.25,386.506,392.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M333.178,409.114c-0.942,0-1.853-0.13-2.158-0.553c-0.107-0.148-0.191-0.401,0.014-0.761 c0.115-0.202,0.301-0.339,0.552-0.407c1.222-0.333,3.79,1.131,3.899,1.193c0.063,0.036,0.097,0.108,0.085,0.179 c-0.012,0.072-0.066,0.128-0.138,0.143C334.963,409.001,334.057,409.114,333.178,409.114z M332.014,407.689 c-0.122,0-0.236,0.012-0.337,0.04c-0.16,0.044-0.272,0.123-0.34,0.244c-0.123,0.216-0.079,0.323-0.034,0.385 c0.342,0.475,2.199,0.485,3.565,0.293C334.186,408.3,332.872,407.689,332.014,407.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M335.398,408.911c-0.024,0-0.048-0.005-0.071-0.015c-0.887-0.398-2.643-1.986-2.509-2.817 c0.031-0.195,0.17-0.438,0.648-0.486c0.355-0.036,0.68,0.064,0.965,0.298c0.935,0.767,1.133,2.746,1.14,2.83 c0.006,0.062-0.021,0.122-0.072,0.158C335.47,408.9,335.434,408.911,335.398,408.911z M333.606,405.933 c-0.034,0-0.069,0.002-0.105,0.005c-0.313,0.032-0.333,0.155-0.34,0.196c-0.081,0.498,1.113,1.747,2.018,2.291 c-0.094-0.578-0.356-1.762-0.97-2.265C334.025,406.008,333.826,405.933,333.606,405.933z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "343.476,408.737 336.13,408.737 335.398,391.724 342.744,391.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "396.978,391.508 389.871,393.365 381.998,377.837 389.106,375.981  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M389.318,392.518l6.293-5.34c0.229-0.194,0.562-0.203,0.802-0.022l5.331,4.04 c0.553,0.419,0.562,1.252,0.025,1.692c-2.229,1.827-3.406,2.603-6.173,4.952c-1.702,1.445-6.834,6.406-9.185,8.401 c-2.299,1.951-4.631-0.069-3.847-1.096c3.515-4.606,5.809-9.095,6.137-11.51C388.76,393.198,388.983,392.802,389.318,392.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M336.178,407.886h8.023c0.3,0,0.56,0.209,0.625,0.502l1.451,6.53 c0.15,0.677-0.364,1.319-1.057,1.307c-2.894-0.049-7.076-0.219-10.713-0.219c-4.253,0-6.111,0.232-11.099,0.232 c-3.016,0-3.853-3.049-2.591-3.325c5.747-1.257,8.625-1.392,13.591-4.454C334.948,408.126,335.544,407.886,336.178,407.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M325.931,172.646c-2.445,4.326-5.001,8.417-7.745,12.492c-2.748,4.053-5.639,8.033-8.818,11.894 c-0.389,0.484-0.808,0.961-1.217,1.439l-0.615,0.717l-0.307,0.358l-0.515,0.546c-1.405,1.423-2.813,2.273-4.164,2.959 c-2.698,1.345-5.261,2.06-7.806,2.634c-5.091,1.087-9.999,1.458-15.069,1.354l-0.55-5.488c4.459-1.201,9.034-2.535,13.158-4.137 c2.041-0.814,4.027-1.725,5.521-2.728c0.73-0.498,1.319-1.032,1.546-1.374l0.845-1.16c0.335-0.463,0.675-0.915,1.001-1.394 c2.652-3.762,5.204-7.695,7.697-11.681c2.499-3.963,4.99-8.037,7.391-11.995L325.931,172.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M365.872,157.994c6.885,1.579,14.782,20.351,14.782,20.351l-13.829,9.478 c0,0-5.239-7.329-9.134-15.529C353.61,163.702,358.832,156.38,365.872,157.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M360.938,169.964l6.54,17.409l-0.65,0.45c0,0-2.83-3.97-5.89-9.33V169.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M324.716,158.372c0,0-7.819,8.832-0.435,63.497c11.839,0,33.532,0,39.293,0 c0.271-6.032-3.519-35.456,2.298-63.876c0,0-6.735-1.352-13.154-1.661c-5.021-0.242-12.29-0.402-16.703,0.001 C330.196,156.864,324.716,158.372,324.716,158.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M329.078,174.176c-0.13,0.16-0.99,9.03-7.76,16.82c-0.16-3.52-0.22-6.68-0.21-9.51L329.078,174.176z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M332.466,164.328c0.969,6.956-12.737,24.726-12.737,24.726l-13.772-9.479 c0,0,3.818-9.793,10.251-16.21C323.552,156.038,331.412,156.757,332.466,164.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M279.567,201.489l-7.695-0.931l0.212,9.382c0,0,6.061,0.52,9.356-3.694L279.567,201.489z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "264.189,202.846 267.185,210.439 272.084,209.939 271.872,200.558  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "335.4,391.729 335.81,401.294 343.159,401.294 342.749,391.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "389.11,375.985 381.999,377.842 386.361,386.437 393.171,383.987  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M351.094,129.437c-0.447,7.277-0.339,11.559-4.014,15.294c-5.529,5.618-14.511,2.286-16.248-4.978 c-1.563-6.538-0.569-17.341,6.554-20.237C344.404,116.663,351.541,122.16,351.094,129.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M337.955,132.833c-3.84-0.778-2.445-5.398-1.5-6.755c-1.278-0.245-1.667-2.134-0.722-2.968 c-1.611,0-5.681-0.278-5.452-5.055c0.229-4.778,3.229-4.222,4.341-1.5c0.667-2.5,3.722-5.445,7.889-4.389 c4.167,1.055,0.499,3.167,0.499,3.167s9.1-1.833,7.834,2.833c3.936,0.222,9.667,3.859,6.778,7.013 c1.714,3.376,1.444,5.686-0.722,6.586c-0.747,4.067-5.064,11.846-8.342,11.846C345.891,143.612,338.177,139.944,337.955,132.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M341.23,131.416c-0.317,1.883-1.388,3.572-2.572,4.625c-1.781,1.583-3.325,0.313-3.378-1.854 c-0.048-1.951,0.822-5.125,2.872-5.883C340.173,127.556,341.592,129.262,341.23,131.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M338.219,221.87c0,0,8.337,56.142,12.914,77.175c5.012,23.033,30.517,84.658,30.517,84.658 l12.798-4.127c0,0-18.416-55.638-21.276-78.443c-3.104-24.75-9.599-79.263-9.599-79.263H338.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M378.931,380.993c-0.055,0.018,2.936,4.473,2.936,4.473l14.379-4.735l-1.706-4.293L378.931,380.993 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M343.488,241.873c9.64,1.89,8.62,37.84,7.46,56.33c-2.78-13.07-6.85-38.22-9.63-56.07 C341.958,241.813,342.678,241.713,343.488,241.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M324.28,221.87c0,0-3.481,54.927-2.682,77.33c0.831,23.302,11.44,99.601,11.44,99.601h12.445 c0,0-2.013-74.937-1.459-97.822c0.604-24.949,6.086-79.108,6.086-79.108H324.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M330.643,393.843c-0.058,0,0.702,5.167,0.702,5.167h15.138l0.409-4.611L330.643,393.843z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingRequested);
export default __webpack_public_path__ + "static/media/billing_requested.df9c122d.svg";
export { ForwardRef as ReactComponent };